import PropTypes from 'prop-types';
import React from 'react';
import Flexbox from 'flexbox-react';
import { css, cx } from 'emotion';
import AbstractForm from 'components/page/process/AbstractForm';
import ProcessUtils from 'utils/ProcessUtils';
import StandardDeviationParameter from 'components/core/fields/transformation_parameters/StandardDeviationParamter';
import GoodValuesParameter from 'components/core/fields/transformation_parameters/GoodValuesParameter';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import InfoMessages from 'components/core/help/InfoMessages';
import MessageBox from 'components/core/MessageBox';
import { colorBorderGrey, colorLabelBlue } from 'styles/base';

const formStyles = css`
    background-color: #fff;
    padding: 8px 15px;
    margin-bottom:15px;
`;

const labelStyles = css`
    color:${colorLabelBlue};
`;

/**
 * The form that renders details for an output datastream
 */
export default class OutputQCForm extends AbstractForm {
    static propTypes = {
        process: PropTypes.object,
        processErrors: PropTypes.object,
        hasWritePermissions: PropTypes.bool,
        exploredDatastreams: PropTypes.object,
        coordinateSystemName: PropTypes.string,
        dimensionName: PropTypes.string,
        className: PropTypes.string,
        border: PropTypes.bool
    };

    shouldSectionBeDisplayed(parameters) {
        let shouldDisplay = false;
        const coordinateSystem = [this.props.coordinateSystemName];
        const dimension = this.props.dimensionName;
        parameters.forEach(parameterName => {
            shouldDisplay = shouldDisplay || ProcessUtils.isRelevantTransformationParameter(this.props.process,
                parameterName, coordinateSystem, dimension, this.props.exploredDatastreams);
        });
        return shouldDisplay;

    }

    render() {
        const displayStdSection = this.shouldSectionBeDisplayed(['std_ind_max', 'std_bad_max'], this.props.dimensionName);
        const displayGoodValuesSection = this.shouldSectionBeDisplayed(['goodfrac_ind_min', 'goodfrac_bad_min'], this.props.dimensionName);

        let wrapperStyle = css`
            padding: 8px 15px;
            .infobox {
                align-self: flex-start !important;
            }
        `;
        if (displayGoodValuesSection || displayStdSection) {
            wrapperStyle = cx(wrapperStyle, css`background-color: #fff;`);
        }
        if (this.props.border) {
            wrapperStyle = cx(wrapperStyle, css`border: 1px solid ${colorBorderGrey};`);
        }

        return (
            <Flexbox flexGrow={1} flexDirection={'column'} className={cx('output-qc-form', this.props.className, wrapperStyle)}>
                {displayStdSection &&
                <Flexbox flexDirection={'column'}>
                    <InfoBoxLabel label={<span>Assessing Standard Deviation in the <span className={labelStyles}>{this.props.dimensionName}</span> Dimension</span>}
                        message={InfoMessages.standardDeviation}
                    />
                    <Flexbox className={cx(formStyles, css`margin-bottom:15px;`)} flexDirection={'column'}>
                        <StandardDeviationParameter
                            process={this.props.process}
                            processErrors={this.props.processErrors}
                            coordinateSystemName={this.props.coordinateSystemName}
                            dimensionName={this.props.dimensionName}
                            exploredDatastreams={this.props.exploredDatastreams}
                            hasWritePermissions={this.props.hasWritePermissions}
                        />
                    </Flexbox>
                </Flexbox>
                }
                {displayGoodValuesSection &&
                <Flexbox flexDirection={'column'}>
                    <InfoBoxLabel label={<span>Assessing Fraction of ‘Good’ Values in the <span className={labelStyles}>{this.props.dimensionName}</span> Dimension</span>}
                        message={InfoMessages.goodFrac}
                    />
                    <Flexbox className={formStyles} flexDirection={'column'}>
                        <GoodValuesParameter
                            process={this.props.process}
                            processErrors={this.props.processErrors}
                            coordinateSystemName={this.props.coordinateSystemName}
                            dimensionName={this.props.dimensionName}
                            exploredDatastreams={this.props.exploredDatastreams}
                            hasWritePermissions={this.props.hasWritePermissions}
                        />
                    </Flexbox>
                </Flexbox>
                }
                {!displayStdSection && !displayGoodValuesSection &&
                    <MessageBox>
                        {/*TODO: This message probably needs to be updated*/}
                        <p>There are no variables where standard deviation or fraction of 'good' values needs to be calculated.</p>
                    </MessageBox>
                }
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/forms/OutputQCForm.js